import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    buttonStyle: {
        minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        height: 40,
        paddingHorizontal: 18,
        marginTop: heightPercentageToDP(16),
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        borderRadius: 999999,
        backgroundColor: blackTransparent(0.33),
    },
    buttonTextStyle: {
        fontFamily: Fonts.main.bold,
        fontSize: 16,
        color: '#F4F9FF',
        textAlign: 'center',
    },
    imageStyle: {
        resizeMode: 'contain',
    },
});

export default styles;
